module.exports = __webpack_public_path__ + "static/media/3pointsIcon.3adf5b4a.svg";